export default __webpack_public_path__ + "static/media/ic-hr-process-icon.5544a000.svg";